import { useCallback } from 'react'

import { Grid, FormControlLabel, Switch, Typography } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { WecAiSchedulersFeatureName } from 'constants/EntityConstants/AppFeature'
import { useChangeAppFeatureStatusMutation, useGetAppFeatureByNameQuery } from 'generated/graphql'
import { usePermission } from 'providers'

const WecAiSchedulersSwitch = () => {
  const [isAllowedToChangeAppFeature] = usePermission('UpdateAppFeature')
  const { control, setValue } = useForm({
    defaultValues: {
      [WecAiSchedulersFeatureName]: false,
    },
  })

  const { loading } = useGetAppFeatureByNameQuery({
    variables: { name: WecAiSchedulersFeatureName },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setValue(WecAiSchedulersFeatureName, data.appFeatureByName!.appFeatureStatus)
    },
  })

  const [changeAppFeatureStatus, { loading: mutationLoading }] = useChangeAppFeatureStatusMutation()

  const handleSwitchChange = useCallback(
    async (value) => {
      if (!isAllowedToChangeAppFeature) return

      setValue(WecAiSchedulersFeatureName, value)

      try {
        await changeAppFeatureStatus({
          variables: { name: WecAiSchedulersFeatureName },
        })
      } catch (e) {
        toast.error('Something went wrong while changing the feature status')
        setValue(WecAiSchedulersFeatureName, !value)
        console.error(e)
        return
      }

      if (value) {
        toast.info(
          'You have turned ON the Schedulers. Now the system would be triggering AI calls.',
          { autoClose: 3000 },
        )
      } else {
        toast.info(
          'You have turned OFF the Schedulers. AI calls and the retry mechanism will not be triggered.',
          { autoClose: 3000 },
        )
      }
    },
    [isAllowedToChangeAppFeature, changeAppFeatureStatus, setValue],
  )

  return (
    <Grid item justifySelf={'flex-end'}>
      <Controller
        control={control}
        name={WecAiSchedulersFeatureName}
        defaultValue={false}
        render={({ field }) => (
          <FormControlLabel
            sx={{ whiteSpace: 'nowrap' }}
            control={
              <Switch
                {...field}
                checked={field.value}
                onChange={(e) => handleSwitchChange(e.target.checked)}
                disabled={loading || mutationLoading}
              />
            }
            label={
              <Typography variant='inherit' fontWeight={'bold'}>
                {'WEC.ai Schedulers'}
              </Typography>
            }
            labelPlacement='start'
          />
        )}
      />
    </Grid>
  )
}

export default WecAiSchedulersSwitch
